export default __webpack_public_path__ + "static/media/INTRO_bg_v02.89221772.mp4";